import { MatchStatus } from '../enums'

export { MatchStatus }

/**
 * Search mandate status
 */
export enum MandateStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  COMPLETED = 'completed',
}

export enum MandateType {
  INVESTMENT = 'investment',
}
